import React from 'react';
import './HowToBuy.css';

const HowToBuy = () => {
  const steps = [
    {
      number: '01',
      title: 'Create a Wallet',
      description: 'Download MetaMask or your preferred Ethereum wallet from the app store or browser extension.',
      icon: '👛'
    },
    {
      number: '02',
      title: 'Get Some ETH',
      description: 'Purchase Ethereum from an exchange like Coinbase or Binance and send it to your wallet.',
      icon: '⚡'
    },
    {
      number: '03',
      title: 'Go to Uniswap',
      description: 'Connect your wallet to Uniswap (app.uniswap.org) and paste the $GOLD contract address.',
      icon: '🦄'
    },
    {
      number: '04',
      title: 'Swap for $GOLD',
      description: 'Swap your ETH for $GOLD. Set slippage to 1-2%. Welcome to the golden revolution!',
      icon: '✨'
    }
  ];

  return (
    <section className="howtobuy" id="howtobuy">
      <div className="container">
        <h2 className="section-title">
          <span className="gold-text">How to Buy</span>
        </h2>

        <div className="steps-container">
          {steps.map((step, index) => (
            <div className="step-card" key={index}>
              <div className="step-number">{step.number}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              {index < steps.length - 1 && <div className="step-connector"></div>}
            </div>
          ))}
        </div>

        <div className="buy-links">
          <a href="https://app.uniswap.org" target="_blank" rel="noopener noreferrer" className="btn-primary">
            Buy on Uniswap 🦄
          </a>
          <a href="https://www.dextools.io" target="_blank" rel="noopener noreferrer" className="btn-secondary btn-dextools">
            View Chart
            <img src="https://cdn.worldvectorlogo.com/logos/dextools.svg" alt="DexTools" className="dextools-icon" />
          </a>
        </div>

        <div className="contract-box">
          <span className="contract-label">Contract Address</span>
          <div className="contract-address-box">
            <code>0xd33794883aE317d753478478543adbeA5aCa5CBE</code>
            <button className="copy-btn" onClick={() => navigator.clipboard.writeText('0xd33794883aE317d753478478543adbeA5aCa5CBE')}>
              📋 Copy
            </button>
          </div>
          <p className="contract-warning">⚠️ Always verify the contract address before swapping!</p>
        </div>
      </div>
    </section>
  );
};

export default HowToBuy;
